import SetupStep from './SetupStep';
import { useLanguage } from '../contexts/language';
import SelectedExperienceChip from './SelectedExperienceChip';

export function SetupHeadphones(p) {
  const { content } = useLanguage();
  return (
    <SetupStep
      title={content('headset')}
      image="headphones"
      badge={<SelectedExperienceChip />}
      action={content('continue')}
      themeSwitcher
      stepNav
      {...p}
    />
  );
}
